<template>
  <p class="medium-title-container">
    <slot/>
  </p>
</template>

<script>
export default {
  name: "MediumTitle"
}
</script>

<style scoped lang="scss">
.medium-title-container {
  color: var(--color-white);
  font-size: 16px;
  font-weight: 400;
}
</style>